export enum NodeType {
  Machine = 4, // Станок
  Node = 5, // Узел
  Other = 6, // Другое
}
